<script>
const sidebarMenu = [
  {
    path: "/in/orders",
    title: "Pedidos",
    children: [
      {
        path: "/in/orders/register",
        title: "Cadastrar Pedido",
      },
      {
        path: "/in/orders/history",
        title: "Histórico de Pedidos",
      },
    ],
  },
];
export default sidebarMenu;
</script>
